import { CatHeading } from '@blocks-react/components/Heading';
import styles from './ContactUsDealerInformationSectionStoreHours.module.scss';
import { CatIconArrowTriangularRight } from '@blocks-react/components/Icons/ArrowTriangularRight';
import { useMemo } from 'react';
import cx from 'classnames';
import { getStoreHours } from '@app/components/dealer-locator/DealerLocatorModal/utils';
import { useTranslation } from 'react-i18next';

const ContactUsDealerInformationSectionStoreHours = ({ storeHours }) => {
  const [t] = useTranslation();

  const sortedStoreHours = useMemo(() => {
    return getStoreHours(storeHours).sort((firstStoreHour, secondStoreHour) => {
      return firstStoreHour.index - secondStoreHour.index;
    });
  }, [storeHours]);

  return (
    <>
      {sortedStoreHours.length > 0 && (
        <div className="cat-u-margin-top-md">
          <CatHeading level="h3" variant="title-sm">
            {t('STORE_HOURS')}:
          </CatHeading>
          <div
            className={
              styles[
                'contactUsPage__dealerInformationSection__content__storeHours'
              ]
            }
          >
            {sortedStoreHours.map(storeHour => (
              <div
                className={cx(
                  styles[
                    'contactUsPage__dealerInformationSection__content__storeHours__hour'
                  ],
                  'mt-1',
                  {
                    [styles[
                      'contactUsPage__dealerInformationSection__content__storeHours__hour--current'
                    ]]: storeHour.currentDay
                  }
                )}
                key={storeHour.label}
              >
                <p
                  className={cx(
                    styles[
                      'contactUsPage__dealerInformationSection__content__storeHours__hour__label'
                    ],
                    'cat-u-margin-none'
                  )}
                >
                  {storeHour.currentDay ? <CatIconArrowTriangularRight /> : ''}
                  {storeHour.label}
                </p>
                <p
                  className={cx(
                    styles[
                      'contactUsPage__dealerInformationSection__content__storeHours__hour__value'
                    ],
                    'cat-u-margin-none'
                  )}
                >
                  {storeHour.value}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default ContactUsDealerInformationSectionStoreHours;
